<template>
  <v-autocomplete
    hide-details="auto"
    :items="billers"
    :loading="loading"
    v-model="filterDatas.biller"
    item-text="first_name"
    item-value="id"
    label="Biller"
    clearable
    outlined
    dense
    @change="emitInput(filterDatas.biller)"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

import { UserViewModel } from '../../models/View Models/UserViewModel';
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    billers: [],
    selectedBiller: null,
    searchBiller: null,
    loading: false,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_BILLER_FILTER', data);
      this.$emit('input', this.filterDatas.biller);
    },

    getBillerByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('user/GetUserSearch', {
          query: this.filterDatas.billerquery
            ? this.filterDatas.billerquery
            : query,

          status: 'active',
        })
        .then((res) => {
          this.billers = res.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedBiller = null;
      },
      deep: true,
    },
    searchBiller: {
      handler(val) {
        this.$store.commit('UPDATE_BILLER_QUERY_FILTER', val);

        this.getBillerByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.biller);
    this.getBillerByQuery();
  },
};
</script>
